import s from "styled-components";

export const CounterWrap = s.div`
  display: flex;
  padding: 15px; 
  position: relative;
  > div:first-child {
    margin-left: 0;
  }
`;
